import { motion } from "framer-motion";
import { useState } from "react";
import { Phone, Mail, MapPin } from "lucide-react";

const ContactSection = () => {
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      const form = e.target;
      const data = new FormData(form);
    
      const res = await fetch("https://formspree.io/f/xwpoblry", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      });
    
      if (res.ok) {
        form.reset();
        setSent(true);
      }
    };

  return (
    <section id="contact" className="bg-brandLight py-20">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-start">
        {/* LEWA STRONA – Info z animacją */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 2.2, ease: [0.25, 1, 0.5, 1] }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <h3 className="text-3xl font-bold text-brandDark mb-6">Kontakt</h3>

          <ul className="space-y-4 text-brandDark text-base">
            <li className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-brandGreen" /> +48 739 454 709
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-brandGreen" /> bartekkostuj@gmail.com
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-brandGreen" /> Czechowice-Dziedzice
            </li>
          </ul>

          <p className="text-textMuted mt-6 text-sm">
            Odpowiadam zazwyczaj w ciągu kilku godzin. Możesz też zadzwonić lub napisać na WhatsApp.
          </p>

          {/* Social media */}
          <div className="flex gap-4 mt-6 text-brandDark">
            {/* Facebook */}
            <a
              href="https://www.facebook.com/JONGLIFTA"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <svg
                className="w-5 h-5 text-brandDark hover:text-brandGreen transition"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2v-2.9h2v-2.2c0-2 1.2-3.2 3-3.2.9 0 1.9.2 1.9.2v2.1h-1c-1 0-1.3.6-1.3 1.2v1.7h2.3l-.4 2.9h-1.9v7A10 10 0 0022 12z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/jonglifta?igsh=eGx6Y3lsZGFobXZh"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg
                className="w-5 h-5 text-brandDark hover:text-brandGreen transition"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-1.8a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z" />
              </svg>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/48739454709"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <svg
                className="w-5 h-5 text-brandDark hover:text-brandGreen transition"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M16 .396c-8.837 0-16 7.163-16 16 0 2.82.738 5.544 2.137 7.952l-2.222 7.652 7.826-2.052a15.914 15.914 0 007.947 2.048c8.837 0 16-7.163 16-16S24.837.396 16 .396zm0 29.603a13.075 13.075 0 01-6.565-1.75l-.471-.273-4.646 1.216 1.239-4.515-.304-.485A13.12 13.12 0 013 16.396c0-7.18 5.82-13 13-13s13 5.82 13 13-5.82 13-13 13zm7.244-9.841c-.397-.198-2.34-1.154-2.702-1.283-.362-.13-.627-.198-.892.198s-1.025 1.283-1.257 1.546c-.23.265-.461.298-.857.099-.397-.198-1.676-.617-3.193-1.966-1.18-1.053-1.977-2.351-2.208-2.748-.23-.397-.024-.612.173-.81.178-.178.397-.464.596-.695.198-.23.265-.397.397-.662.132-.265.066-.497-.033-.695-.099-.198-.892-2.152-1.222-2.942-.32-.772-.647-.668-.892-.678l-.76-.01c-.265 0-.695.099-1.057.497s-1.39 1.357-1.39 3.302 1.423 3.827 1.622 4.094c.198.265 2.804 4.28 6.788 6.002.949.409 1.688.653 2.267.835.952.303 1.818.26 2.503.158.764-.114 2.34-.956 2.671-1.878.33-.923.33-1.714.231-1.878-.099-.165-.362-.265-.76-.464z" />
              </svg>
            </a>
          </div>
        </motion.div>

         {/* PRAWA STRONA – Formularz z Formspree */}
         <form onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-lg p-8 space-y-6"
        >
          <input
            type="text"
            name="name"
            required
            placeholder="Imię i nazwisko"
            className="w-full border-b border-gray-300 py-2 focus:outline-none focus:border-brandGreen bg-transparent"
          />
          <input
            type="email"
            name="email"
            required
            placeholder="Adres e-mail"
            className="w-full border-b border-gray-300 py-2 focus:outline-none focus:border-brandGreen bg-transparent"
          />
          <textarea
            name="message"
            required
            placeholder="Wiadomość"
            rows="4"
            className="w-full border-b border-gray-300 py-2 resize-none focus:outline-none focus:border-brandGreen bg-transparent"
          ></textarea>
          <button
            type="submit"
            className="bg-brandGreen text-white px-6 py-3 rounded-lg hover:bg-brandGreenDark transition"
          >
            Wyślij wiadomość
          </button>
          {sent && (
            <p className="text-sm text-brandGreen mt-2">
              Wiadomość została wysłana ✅
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactSection;